import { useUserStore } from '@talon/web/src/context';
import { Text } from 'grommet';
import React, { useEffect } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { ChatMessage, Conversation, MessageType } from '../../../../lib/api';
import { env } from '../../../config/env';

export type ITypingPayload = {
  conversation_id: string;
  user_id: string;
  first_name: string;
};

interface ISupportChat {
  setMessageState: React.Dispatch<
    React.SetStateAction<{
      conversationId?: string;
      messages: Array<Partial<ChatMessage>>;
      pending?: string;
    }>
  >;
  updateConversations?: (conversation: Conversation) => void;
  addConversation?: (conversation: Conversation) => void;
  onTyping?: (payload: ITypingPayload) => void;
  messageToSend?: Partial<ChatMessage>;
  conversationId: string;
}

export const SupportChat = ({
  setMessageState,
  messageToSend,
  conversationId,
  updateConversations,
  addConversation,
  onTyping,
}: ISupportChat) => {
  const userStore = useUserStore();
  const queryParams = {
    c: conversationId,
  };
  const { sendJsonMessage, lastMessage, readyState } = useWebSocket(`${env.apiWsHost}:${env.apiPort}`, {
    queryParams,
    protocols: ['Authorization', userStore.token],
    onError: (e) => {
      console.log('error', e);
    },
    share: true,
  });

  useEffect(() => {
    if (lastMessage !== null) {
      const data = lastMessage.data;
      const msgJson = JSON.parse(data);

      if (msgJson.type === MessageType.NOTIFICATION) return;

      switch (msgJson.type) {
        case MessageType.NEW_CONVERSATION:
          addConversation && addConversation(msgJson.conversation);
          break;
        case MessageType.UPDATED_CONVERSATION:
          updateConversations && updateConversations(msgJson.conversation);
          break;
        case MessageType.TYPING:
          onTyping && onTyping(msgJson as unknown as ITypingPayload);
          break;
        default:
          setMessageState((state) => ({
            ...state,
            messages: [
              ...state.messages,
              {
                ...msgJson,
              },
            ],
            conversationId: msgJson.conversation_id,
          }));
      }
    }
  }, [lastMessage]);

  useEffect(() => {
    if (messageToSend) {
      sendJsonMessage(messageToSend);
    }
  }, [messageToSend]);

  const connectionStatus = {
    [ReadyState.CONNECTING]: 'Connecting',
    [ReadyState.OPEN]: 'Open',
    [ReadyState.CLOSING]: 'Closing',
    [ReadyState.CLOSED]: 'Closed',
    [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
  }[readyState];

  return (
    <Text margin={{ horizontal: 'small' }} size="xsmall" alignSelf="start">
      {' '}
      Support chat is: {connectionStatus}. Channel: {conversationId}.{' '}
    </Text>
  );
};
